/* FFL PDP customer video reviews lightbox. Card clicks are delegated so they
   keep working after the product-info column re-renders on variant change. */
(function(){
  function init(){
    var lb=document.querySelector('.ffl-vrlb');
    if(!lb){return;}
    var video=lb.querySelector('.ffl-vrlb__video');
    var playbtn=lb.querySelector('[data-vrlb-play]');
    var muteBtn=lb.querySelector('[data-vrlb-mute]');
    var closers=lb.querySelectorAll('[data-vrlb-close]');
    var lastFocus=null;
    function showPlay(show){ if(!playbtn){return;} if(show){ playbtn.removeAttribute('hidden'); } else { playbtn.setAttribute('hidden',''); } }
    function open(src,poster){
      if(!src){return;}
      lastFocus=document.activeElement;
      video.setAttribute('src',src);
      if(poster){ video.setAttribute('poster',poster); } else { video.removeAttribute('poster'); }
      try{ video.currentTime=0; }catch(e){}
      video.muted=false; lb.classList.remove('is-muted');
      lb.hidden=false; lb.setAttribute('aria-hidden','false');
      document.body.classList.add('ffl-vrlb-open');
      showPlay(false);
      var p=video.play();
      if(p&&p.catch){ p.catch(function(){ video.muted=true; lb.classList.add('is-muted'); var p2=video.play(); if(p2&&p2.catch){ p2.catch(function(){ showPlay(true); }); } }); }
    }
    function close(){
      video.pause();
      lb.hidden=true; lb.setAttribute('aria-hidden','true');
      document.body.classList.remove('ffl-vrlb-open');
      showPlay(false);
      try{ video.removeAttribute('src'); video.load(); }catch(e){}
      if(lastFocus&&lastFocus.focus){ try{ lastFocus.focus(); }catch(e){} }
    }
    document.addEventListener('click',function(e){
      var card=e.target.closest?e.target.closest('.ffl-vr__card'):null;
      if(card){ e.preventDefault(); open(card.getAttribute('data-vr-src'),card.getAttribute('data-vr-poster')); }
    });
    video.addEventListener('click',function(){ if(video.paused){ video.play(); } else { video.pause(); } });
    if(playbtn){ playbtn.addEventListener('click',function(e){ e.stopPropagation(); video.play(); }); }
    video.addEventListener('play',function(){ showPlay(false); });
    video.addEventListener('pause',function(){ if(!lb.hidden){ showPlay(true); } });
    video.addEventListener('ended',function(){ showPlay(true); });
    if(muteBtn){ muteBtn.addEventListener('click',function(){ video.muted=!video.muted; lb.classList.toggle('is-muted',video.muted); }); }
    Array.prototype.forEach.call(closers,function(c){ c.addEventListener('click',close); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!lb.hidden){ close(); } });
  }
  if(document.readyState!=='loading'){ init(); } else { document.addEventListener('DOMContentLoaded',init); }
})();